import { render, staticRenderFns } from "./LoginSetup.vue?vue&type=template&id=5fb444c4&scoped=true&"
import script from "./LoginSetup.vue?vue&type=script&lang=js&"
export * from "./LoginSetup.vue?vue&type=script&lang=js&"
import style0 from "./LoginSetup.vue?vue&type=style&index=0&id=5fb444c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb444c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/krankerl.7m6CVIT2x327/twofactor_totp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb444c4')) {
      api.createRecord('5fb444c4', component.options)
    } else {
      api.reload('5fb444c4', component.options)
    }
    module.hot.accept("./LoginSetup.vue?vue&type=template&id=5fb444c4&scoped=true&", function () {
      api.rerender('5fb444c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoginSetup.vue"
export default component.exports